import { render, staticRenderFns } from "./NormalSearchNav561.vue?vue&type=template&id=b8167134&scoped=true"
import script from "./NormalSearchNav561.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav561.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8167134",
  null
  
)

export default component.exports